import React from "react";
import TextInput from "../../../../components/Input/TextInput";

const BackendDropdown = ({ form }) => {
  return (
    <>
      <TextInput label={"GAP"} placeholder="GAP" form={form} validateName="GAP" size="xs" />
      <TextInput label={"VSI Insurance"} placeholder="VSI Insurance" form={form} validateName="VSI" size="xs" />
    </>
  );
};

export default BackendDropdown;
